import type { ContentItem } from '@/api/v4/content-items.api';
import type { ISort } from '@/ui/table/table.types';
import { atom } from 'jotai';

export const contentItemInEditModeState = atom<ContentItem | null>(null);

export enum ContentItemSortKey {
  category = 'category',
  createdDate = 'createdDate',
  isVisible = 'isVisible',
  title = 'title',
  uploadedDate = 'uploadedDate',
}

export const contentItemsSortState = atom<ISort<ContentItemSortKey>>({
  sort: ContentItemSortKey.uploadedDate,
  direction: 'desc',
});
